import { Link } from '@inertiajs/react'

const typeLabels = {
  credit_purchase: 'Achat de crédits',
  lead_purchase: 'Achat de lead',
  refund: 'Remboursement',
  bonus: 'Bonus'
}

const statusColors = {
  pending: 'bg-yellow-100 text-yellow-800',
  completed: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  refunded: 'bg-gray-100 text-gray-800'
}

const statusLabels = {
  pending: 'En attente',
  completed: 'Complété',
  failed: 'Échoué',
  refunded: 'Remboursé'
}

export default function RecentTransactionsList({ transactions, compact = false }) {
  if (!transactions || transactions.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>Aucune transaction récente</p>
        <Link href="/transactions" className="text-primary-600 hover:text-primary-700 text-sm mt-2 inline-block">
          Voir toutes les transactions →
        </Link>
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {transactions.slice(0, compact ? 5 : transactions.length).map((transaction) => (
        <Link
          key={transaction.id}
          href={`/transactions/${transaction.id}`}
          className="block p-3 rounded-lg border border-gray-200 hover:border-primary-300 hover:bg-primary-50 transition-colors"
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h4 className="font-medium text-gray-900 text-sm">
                  {typeLabels[transaction.transaction_type]}
                </h4>
                <span className={`px-2 py-0.5 text-xs font-medium rounded ${statusColors[transaction.status]}`}>
                  {statusLabels[transaction.status]}
                </span>
              </div>
              <div className="text-xs text-gray-500">
                {transaction.credit_pack && (
                  <span>{transaction.credit_pack.name} - {transaction.credit_pack.credits + transaction.credit_pack.bonus_credits} crédits</span>
                )}
                {transaction.lead && (
                  <span>Lead: {transaction.lead.first_name} {transaction.lead.last_name}</span>
                )}
              </div>
            </div>
            <div className="text-right">
              <div className="font-semibold text-gray-900">
                {(transaction.final_price / 100).toFixed(2)}€
              </div>
              <div className="text-xs text-gray-400">
                {new Date(transaction.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}
